export default __webpack_public_path__ + "static/media/greenshield_health.png";